import { Component } from '@angular/core';
import { NotificationService } from 'src/app/source/shared/notifications/services/notification.service';

@Component({
  selector: 'app-footer-mobile',
  templateUrl: './footer-mobile.component.html',
  styleUrls: ['./footer-mobile.component.scss']
})
export class FooterMobileComponent {

  constructor(private notificationService: NotificationService) {}

  onNotificationClick() {
    this.notificationService.openPanel();
  }

}
